import { useEffect, useRef } from "react";
import "./css/d4.css";

export default function MenuTemplate4({ menu, categories }) {
  const catRefs = useRef({});

  // Auto-scroll on category tap
  const scrollToCat = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  const colors = menu.colors || {
    primary: "#000",
    background: "#fafafa",
    text: "#1f1f1f",
    card: "#ffffff",
  };
  return (
    <div className="crazy-wrapper">
      
      
      {/* 🔥 HERO SECTION */}
      <header className="crazy-hero">
        {menu.imageUrl && (
          <img src={menu.imageUrl} alt="header" className="crazy-hero-img" />
        )}

        <div className="crazy-hero-overlay">
          <h1 style={{color: "white"}} className="crazy-hero-title">{menu.name}</h1>
          {menu.tagline && (
            <p style={{color: "white"}} className="crazy-hero-sub">{menu.tagline}</p>
          )}
        </div>
      </header>

      {/* 🔥 FLOATING CATEGORY SCROLLER */}
      <div className="crazy-cat-scroll">
        {categories.map((cat) => (
          <span
            key={cat.id}
            style={{backgroundColor: colors.primary, zIndex: 500}}
            className="crazy-cat-pill"
            onClick={() => scrollToCat(cat.id)}
          >
            {cat.name}
          </span>
        ))}
      </div>

      {/* 🔥 MENU CONTENT */}
      <main className="crazy-menu">
        {categories.map((cat) => (
          <section key={cat.id} id={cat.id} className="crazy-section fade-in">
            <h2 className="crazy-section-title">{cat.name}</h2>

            <div className="crazy-item-grid">
              {cat.items.map((item) => (
                <div className="crazy-item-card" style={{backgroundColor: colors.card}} key={item.id}>
                  
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="crazy-item-img"
                    />
                  )}

                  <div className="crazy-item-info">
                    <h3 style={{color: colors.text}}>{item.name}</h3>
                    {item.description && (
                      <p className="crazy-item-desc" style={{color: colors.text, opacity: .8}}>{item.description}</p>
                    )}
                  </div>

                  <span style={{color: colors.text}} className="crazy-price">
                    ${parseFloat(item.price).toFixed(2)}
                  </span>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
